<template>

	<div>
		<layout :mastheadBackgroundImage="require('img/mastheads/news.jpg')">
			<div slot="masthead" class="center">
				<masthead>
					<template slot="headline">News</template>
				</masthead>
			</div>
			<div slot="body">
				<NewsListings :entries="entries" />
			</div>
			<template slot="footer">
				<FooterCTA />
			</template>
		</layout>
	</div>

</template>

<script>

	import Layout from '@/layouts/layoutA'
	import Masthead from '@/layouts/layoutA/masthead'
	import FooterCTA from '@/components/FooterCTA'
	import NewsListings from '@/components/NewsListings'

	const storePrefix = 'entities/news'

	export default {
		components: { Layout, Masthead, NewsListings, FooterCTA },
		metaInfo: {
			title: "StudySync News"
		},
		data () {
			return {
			}
		},
		created () {
			this.$store.dispatch(`${storePrefix}/fetchAll`)
		},
		computed: {
			entries () {
				return this.$store.getters[`${storePrefix}/query`]()
					.orderBy('postDate', 'desc')
					.get()
			}
		},
	}
</script>

<style lang="scss" scoped>
	.body {

	}
</style>



// WEBPACK FOOTER //
// src/routes/news/index.vue